// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'es6-proxy-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import http from './assets/js/http'
// import VueClipboards from 'vue-clipboards'
import 'element-ui/lib/theme-chalk/index.css'
import { getCookie } from './assets/js/cookie'
// 引入全局css
import './assets/css/global.css'
// require styles
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// 富文本

import zhLocale from './assets/lang/cn'
import enLocale from './assets/lang/en'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang

Vue.use(VueI18n)
// axios封装
Vue.use(http)
// Vue.use(ElementUI)

// Vue.use(VueClipboards)
const i18n = new VueI18n({
  // locale: 'EN', // 语言标识
  // locale: 'CN',
  locale: getCookie('PLAY_LANG', 'EN'), // 语言标识
  messages: {
    // 中文语言包
    'CN': { ...elementZhLocale, ...zhLocale },
    // 英文语言包
    'EN': { ...elementEnLocale, ...enLocale }
  }
})

function isMobile () {
  var userAgenInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'iPad', 'iPod']
  var flag = false
  for (var v = 0; v < Agents.length; v++) {
    if (userAgenInfo.indexOf(Agents[v]) > 0) {
      flag = true
      break
    }
  }
  return flag
}

window.ismobile = isMobile()

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
window.i18n = i18n

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js